/** 会话链接只包含稳定业务 ID；不携带令牌、任意地址或文件路径。 */
export interface ConversationLink { sessionId: string; clientId?: string }
/** URL 入参必须先验证，避免路径拼接和临时会话被持久化。 */
function validId(value: string | null): value is string {
  return Boolean(value && !value.startsWith('temp-') && /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/.test(value));
}
/** 无 session 参数或参数不合法时返回 null；权限仍由云端/Relay 的当前账号校验。 */
export function readConversationLink(href: string): ConversationLink | null {
  const url = new URL(href);
  const sessionId = url.searchParams.get('session'), clientId = url.searchParams.get('client');
  if (!validId(sessionId) || (clientId !== null && !validId(clientId))) return null;
  return { sessionId, ...(clientId ? { clientId } : {}) };
}
/** 生成可复制地址，主动去除当前页面上所有无关查询参数与 fragment。 */
export function buildConversationLink(href: string, value: ConversationLink | null): string {
  const current = new URL(href);
  const url = new URL(current.pathname, current.origin);
  if (value) {
    if (!validId(value.sessionId) || (value.clientId !== undefined && !validId(value.clientId))) throw new Error('Invalid session link');
    url.searchParams.set('session', value.sessionId);
    if (value.clientId) url.searchParams.set('client', value.clientId);
  }
  return url.href;
}
